import React from 'react';
import { MetaPixel } from '../components/MetaPixel';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { ReasonsSection } from '../components/ReasonsSection';
import { ProblemSection } from '../components/ProblemSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { MidCTASection } from '../components/MidCTASection';
import { TransformationSection } from '../components/TransformationSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-garden-medium selection:text-white" data-id="element-235">
      <MetaPixel data-id="element-236" />
      <UrgencyBar data-id="element-237" />
      <main data-id="element-238">
        <HeroSection data-id="element-239" />
        <ReasonsSection data-id="element-240" />
        <ProblemSection data-id="element-241" />
        <PainPointsSection data-id="element-242" />
        <SolutionSection data-id="element-243" />
        <IncludesSection data-id="element-244" />
        <MidCTASection data-id="element-245" />
        <TransformationSection data-id="element-246" />
        <BonusSection data-id="element-247" />
        <PricingSection data-id="element-248" />
        <GuaranteeSection data-id="element-249" />
        <TestimonialsSection data-id="element-250" />
        <FAQSection data-id="element-251" />
        <FinalCTASection data-id="element-252" />
      </main>
      <Footer data-id="element-253" />
      <PurchasePopup data-id="element-254" />
    </div>;
}